export const HomePageExplore = [
  {
    tag: "Free",
    courses: [
      {
        heading: "Introduction to JavaScript",
        description:
          "Learn the basics of JavaScript, from variables and functions to DOM manipulation and events.",
        level: "Beginner",
        lessionNumber: 5,
      },
      {
        heading: "Basics of Python",
        description:
          "Get started with Python programming with simple projects and exercises to strengthen your skills.",
        level: "Beginner",
        lessionNumber: 6,
      },
      {
        heading: "Git & Version Control",
        description:
          "Understand Git commands, repositories, and version control workflows for collaborative projects.",
        level: "Beginner",
        lessionNumber: 4,
      },
    ],
  },
  {
    tag: "New to coding",
    courses: [
      {
        heading: "Introduction to HTML & CSS",
        description:
          "Build and style your first web pages using HTML structure and CSS design techniques.",
        level: "Beginner",
        lessionNumber: 5,
      },
      {
        heading: "Intro to SQL",
        description:
          "Learn how to create, read, update, and delete data in databases using SQL queries.",
        level: "Beginner",
        lessionNumber: 5,
      },
      {
        heading: "Web Accessibility Basics",
        description:
          "Learn how to make websites accessible and inclusive for all users, including assistive technologies.",
        level: "Beginner",
        lessionNumber: 3,
      },
    ],
  },
  {
    tag: "Most popular",
    courses: [
      {
        heading: "React Fundamentals",
        description:
          "Build dynamic front-end applications using React components, state, and props.",
        level: "Beginner",
        lessionNumber: 6,
      },
      {
        heading: "Node.js Essentials",
        description:
          "Learn server-side programming with Node.js and create RESTful APIs for your apps.",
        level: "Beginner",
        lessionNumber: 6,
      },
      {
        heading: "TypeScript Basics",
        description:
          "Add type safety to your JavaScript projects with TypeScript fundamentals.",
        level: "Beginner",
        lessionNumber: 5,
      },
    ],
  },
  {
    tag: "Skills paths",
    courses: [
      {
        heading: "Full-Stack Web Development",
        description:
          "Combine front-end and back-end skills to build complete web applications.",
        level: "Intermediate",
        lessionNumber: 8,
      },
      {
        heading: "API Development with Express",
        description:
          "Learn to design and build APIs with Express.js for scalable web applications.",
        level: "Intermediate",
        lessionNumber: 7,
      },
      {
        heading: "Data Structures & Algorithms",
        description:
          "Master fundamental data structures and algorithms to improve problem-solving skills.",
        level: "Intermediate",
        lessionNumber: 10,
      },
    ],
  },
  {
    tag: "Career paths",
    courses: [
      {
        heading: "MERN Stack Development",
        description:
          "Build modern full-stack applications with MongoDB, Express, React, and Node.js.",
        level: "Advanced",
        lessionNumber: 12,
      },
      {
        heading: "DevOps Essentials",
        description:
          "Learn deployment, CI/CD pipelines, and server management for professional projects.",
        level: "Advanced",
        lessionNumber: 8,
      },
      {
        heading: "Cloud Computing with AWS",
        description:
          "Understand cloud infrastructure and services to deploy and scale applications effectively.",
        level: "Advanced",
        lessionNumber: 9,
      },
    ],
  },
];
